import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  AppShell,
  CardPanel,
  PageHeader,
  StatusCheckCard,
} from "../components";

const ConfirmationPage = () => {
  const navigate = useNavigate();
  const [studentName, setStudentName] = useState("Friend");
  const [attendanceStatus, setAttendanceStatus] = useState("marked");
  const [attendanceMessage, setAttendanceMessage] = useState("");

  useEffect(() => {
    const storedName = localStorage.getItem("student_name");
    const storedAttendanceStatus = localStorage.getItem("attendance_status");
    const storedAttendanceMessage = localStorage.getItem("attendance_message");

    if (storedName && storedName.trim()) {
      const firstName = storedName.trim().split(" ")[0];
      setStudentName(firstName || "Friend");
    }

    if (storedAttendanceStatus && storedAttendanceStatus.trim()) {
      setAttendanceStatus(storedAttendanceStatus);
    }

    if (storedAttendanceMessage && storedAttendanceMessage.trim()) {
      setAttendanceMessage(storedAttendanceMessage);
    }
  }, []);

  const handleAskClick = () => {
    navigate("/QuestionPage");
  };

  return (
    <AppShell logoPosition="bottom">
      <PageHeader
        title={<>Good to see you, {studentName}</>}
        className="ui-page-header--centered-row ui-page-header--actions"
      />

      <CardPanel className="ui-card-panel--wide">
        <StatusCheckCard
          subtitle={<>Thanks for being part of today’s class.</>}
          description="Have a Question?"
          actionLabel="Ask"
          onAction={handleAskClick}
          actionVariant="danger"
        />
      </CardPanel>
    </AppShell>
  );
};

export default ConfirmationPage;
